const Component = () => import('./WhyShop');

export { Component };
